/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";
import "../../../assets/styles/custom-style.scss";
import { useAuth } from "../../../auth";
import {
  listOrdersData,
  getStatus,
} from "../core/_requests";
import { useNavigate } from "react-router-dom";


interface Orders {
  primaryId: number;
  orderstatusId: number;
  uuid: string;
  orderId: string;
  chefId: string;
  userId: string;
  amount: number;
  tax: number;
  deliveryCharge: number;
  deliveryType: number;
  couponApplied: boolean;
  couponAmount: number | null;
  walletDiscount: number | null;
  deliveryPersonTips: number;
  chefTips: number;
  paymentMethod: string;
  netValue: number;
  orderDate: string;
  orderTime: string;
  totalAmount: number;
  orderstatus: {
    name: string;
  };
  chef: {
    name: string;
    currentlyAvailableStatus: boolean;
    email: string;
    phoneNumber: string | null;
    phoneNumber1: string | null;
    mobileNumber: string;
    mobileNumber1: string | null;
    location: string | null;
    licence: string | null;
    chefProfile: string | null;
    approvalStatus: boolean;
    address: string;
    city: string;
    state: string;
    country: string;
    zipCode: string;
    status: number;
    enableDisableStatus: boolean;
  };
  orderdetails: [
    {
      id: number;
      orderId: string;
      dishId: string;
      quantity: number;
      amount: number;
      dish: {
        name: string;
        dishImage: string;
        price: number;
        addons: [
          {
            id: number;
            name: string;
            quantity: number;
            price: number;
          }
        ];
      };
    }
  ];
  user: {
    id: number;
    uuid: string;
    userProfile: string;
    deviceId: string | null;
    token: string;
    verifyStatus: string | null;
    deviceType: string | null;
    deviceToken: string | null;
    loginType: string | null;
    name: string;
    email: string;
    latitude: string | null;
    longitude: string | null;
    contactNumber: string;
    plansId: string | null;
    planStartDate: string | null;
    planEndDate: string | null;
    planStatus: string | null;

    addressbooks: [
      {
        label: string;
        address1: string;
        address2: string;
        city: string;
        state: string;
        country: string;
        zipcode: any;
      }
    ];
  };
}
interface Status {
  id: number;
  name: string;
  active?: boolean;
}

const MenuOrders = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [chefStatus, setChefStatus] = useState<boolean>(
    currentUser?.currentlyAvailableStatus ?? false
  );
  const [listOrders, setListOrders] = useState<Orders[]>([]);
  const [status, setStatus] = useState<Status[]>([]);
  const [loading, setLoading] = useState(true);
  const chefId = currentUser?.uuid
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");

  useEffect(() => {
    getStatus()
      .then((res) => {
        const statusData = res?.data?.data.map((s: any) => ({
          ...s,
          active: s.name === "ordered", // Set active to true for "ordered" status
        }));
        setStatus(statusData);
      })
      .catch((error) => {
        console.error("Error fetching order statuses:", error);
      });
  }, []);
  useEffect(() => {
    listOrdersData(chefId).then((res) => {
      setListOrders(res?.data);
      setLoading(false);
    });
  }, [chefId]);
  useEffect(() => {
    if (chefStatus) {
      setNotificationMessage("You are online now");
    } else {
      setNotificationMessage("You are offline");
    }

    setShowNotification(true);
    setTimeout(() => {
      setShowNotification(true);
    }, 60000);
  }, [chefStatus]);

  useEffect(() => {
    const currentStatus = false;
    setChefStatus(currentStatus);
  }, []);

  useEffect(() => {
    const storedStatus = localStorage.getItem("chefStatus");
    if (storedStatus !== null) {
      setChefStatus(JSON.parse(storedStatus));
    }
  }, []);

  const openHistory = () => {
        navigate("/orders/history");
  };

  return (
    <>

      <div className="col-12 title-btm mt-2 flex-row align-items-center">
        <div className="title">
          <h3 className="mb-0">Orders</h3>
        </div>

        <div className="d-flex align-items-center">
          <button
            className="btn btn-primary btn-ico rounded-5 btn-empty"
            onClick={openHistory}
          >
            <i className="material-symbols-outlined">history</i>
            <span>History</span>
          </button>

        </div>
      </div>
    </>
  );
};

export default MenuOrders;
